import makeActionCreator from './makeActionCreator';
import {
  CLEAR_ROSTER_UPLOAD,
  UPLOAD_ROSTER,
  UPLOAD_ROSTER_DONE,
  UPLOAD_ROSTER_ERROR,
  UPLOAD_ROSTER_LOADING,
  UPLOAD_ROSTER_SUCCESS
} from './actionTypes';

export const uploadRoster = makeActionCreator(UPLOAD_ROSTER, 'eventId', 'csv');
export const uploadRosterLoading = makeActionCreator(UPLOAD_ROSTER_LOADING);
export const uploadRosterSuccess = makeActionCreator(UPLOAD_ROSTER_SUCCESS, 'roster');
export const uploadRosterError = makeActionCreator(UPLOAD_ROSTER_ERROR, 'error');
export const uploadRosterDone = makeActionCreator(UPLOAD_ROSTER_DONE);

export const clearRosterUpload = makeActionCreator(CLEAR_ROSTER_UPLOAD);
